import React, { useRef } from "react"
import { useReadMoreButton } from "../../hooks"

const Description = ({ data }) => {
  const descriptionSection = useRef(null)

  useReadMoreButton(descriptionSection, "Read More", "Read Less")

  if (!data) return <div></div>
  const { title = "", desc = "", html = "" } = data?.attributes

  return (
    <section
      className="max-w-screen-2xl w-full px-7 2xl:px-0 mx-auto mt-14 lg:mt-[200px] mb-10"
      ref={descriptionSection}
    >
      <div className="max-w-screen-xl w-full mx-auto lg:flex items-center justify-between">
        <div
          className="font-cardo sm:font-cardo--46 sm:font-cardo--53 mb-10 leading-none self-start"
          dangerouslySetInnerHTML={{ __html: title }}
        ></div>
        <div
          className="lg:max-w-xl xl:max-w-screen-md font-montserrat--18 lg:px-7"
          dangerouslySetInnerHTML={{ __html: desc }}
        ></div>
      </div>
      <div dangerouslySetInnerHTML={{ __html: html ?? "" }} />
    </section>
  )
}

export default Description
